// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__19eF3","ranges":"BmiRanges_ranges__1gNhZ"};